import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header border-0 pt-6" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "fw-bolder m-0" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_9 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "svg-icon svg-icon-3" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header border-0 pt-6" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = { class: "fw-bolder m-0" }
const _hoisted_16 = { class: "card-toolbar" }
const _hoisted_17 = { class: "card-body pt-0" }
const _hoisted_18 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'indices'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.translate('priceIndexMethodology')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.can('update', 'indices'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-light-primary btn-sm",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editDetailed(_ctx.priceDetailedKey)))
                  }, _toDisplayString(_ctx.translate('detailedMethodologyPrice')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.priceIndexItems,
              "table-header": _ctx.tableHeader,
              loading: _ctx.loading,
              "rows-per-page": 20,
              total: _ctx.priceIndexItems.length,
              "enable-items-per-page-dropdown": false
            }, {
              "cell-titleEn": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.titleEn), 1)
              ]),
              "cell-titleAr": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.titleAr), 1)
              ]),
              "cell-isActive": _withCtx(({ row: item }) => [
                (item.isActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.translate('active')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.translate('inactive')), 1))
              ]),
              "cell-updatedAt": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(item.updatedAt)), 1)
              ]),
              "cell-actions": _withCtx(({ row: item }) => [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.editItem(item.id)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                  ])
                ], 8, _hoisted_10)
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "loading", "total"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.translate('volumeIndexMethodology')), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.can('update', 'indices'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-light-primary btn-sm",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editDetailed(_ctx.volumeDetailedKey)))
                  }, _toDisplayString(_ctx.translate('detailedMethodologyVolume')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.volumeIndexItems,
              "table-header": _ctx.tableHeader,
              loading: _ctx.loading,
              "rows-per-page": 20,
              total: _ctx.volumeIndexItems.length,
              "enable-items-per-page-dropdown": false
            }, {
              "cell-titleEn": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.titleEn), 1)
              ]),
              "cell-titleAr": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.titleAr), 1)
              ]),
              "cell-isActive": _withCtx(({ row: item }) => [
                (item.isActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.translate('active')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.translate('inactive')), 1))
              ]),
              "cell-updatedAt": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(item.updatedAt)), 1)
              ]),
              "cell-actions": _withCtx(({ row: item }) => [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.editItem(item.id)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                  ])
                ], 8, _hoisted_20)
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "loading", "total"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}